module.exports = __webpack_public_path__ + "img/logo-light-mobile.c0a538e1.svg";